/**
 * @file: SecureStorageProvider.web.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { AsyncStorageProvider } from './AsyncStorageProvider';

export const SecureStorageProvider = AsyncStorageProvider;
